import { SENSOR_CODE, SENSOR_PIN_CODE, SENSOR_TYPE } from '@/router/views/report/lib/variables'

const invalidValue = () => ({ value: null, display: '-' })

function numericValue(value) {
  if (typeof value !== 'number' && typeof value !== 'string') return null
  if (typeof value === 'string' && !value.trim()) return null
  const number = Number(value)
  return Number.isFinite(number) ? number : null
}
function rawValue(value) {
  const number = numericValue(value)
  return number === null ? invalidValue() : { value: number, display: String(value) }
}
function getLowerUpperFuelValues(value) {
  switch (value) {
    case 20:
      return { lower: 0, upper: 20, upperValue: 20.99 }
    case 40:
      return { lower: 21, upper: 40, upperValue: 40.99 }
    case 60:
      return { lower: 41, upper: 60, upperValue: 60.99 }
    case 80:
      return { lower: 61, upper: 80, upperValue: 80.99 }
    case 100:
      return { lower: 81, upper: 100, upperValue: 100 }
    default:
      return null
  }
}
export function normalizeFuelValues(sensors, fuel, fuelPercentage, fuelCapacity, isScoped) {
  const isOdo = sensors?.some((sensor) => sensor.sensorCode == SENSOR_CODE.FUEL_ODO) && isScoped
  if (!isOdo) {
    return { fuel: rawValue(fuel), fuelPercentage: rawValue(fuelPercentage) }
  }
  const percentage = numericValue(fuelPercentage)
  if (![20, 40, 60, 80, 100].includes(percentage)) {
    return { fuel: invalidValue(), fuelPercentage: invalidValue() }
  }
  const lowerUpper = getLowerUpperFuelValues(percentage)
  if (!lowerUpper) {
    return { fuel: invalidValue(), fuelPercentage: invalidValue() }
  }
  const { lower, upper, upperValue } = lowerUpper
  const resultPercentage = { value: percentage, display: `${lower}-${upper}` }
  const capacity = numericValue(fuelCapacity)
  if (capacity === null || capacity <= 0)
    return { fuel: invalidValue(), fuelPercentage: resultPercentage }
  const upperLiters = Math.floor((upperValue / 100) * capacity)
  const lowerLiters = lower === 0 ? '0' : Math.floor((lower / 100) * capacity)
  return {
    fuel: { value: Number(upperLiters), display: `${lowerLiters}-${upperLiters}` },
    fuelPercentage: resultPercentage,
  }
}
export function formatFuelTooltip(tooltipItem, chartData) {
  const dataset = chartData.datasets[tooltipItem.datasetIndex]
  const display = dataset.tableValues?.[tooltipItem.index]
  const value = display === undefined ? tooltipItem.value ?? tooltipItem.yLabel ?? '' : display
  const unit = display === undefined || !dataset.unit ? '' : ` ${dataset.unit}`
  return `${dataset.label ? `${dataset.label}: ` : ''}${value}${unit}`
}
function isHaveFuelSensor(sensors, sensorCode, pinCode) {
  if (Array.isArray(pinCode)) {
    return sensors?.some((item) => sensorCode == item.sensorCode && pinCode.includes(item.pinCode))
  }
  return sensors?.some(
    (item) => item.sensorCode == sensorCode && (!pinCode || item.pinCode == pinCode)
  )
}
export function getFuelSensorString(sensors, type) {
  if (type == 'C' && isHaveFuelSensor(sensors, SENSOR_CODE.FUEL_OBD, SENSOR_PIN_CODE.FUEL_OBD)) {
    return 'OBD'
  } else if (
    type == 'L' &&
    isHaveFuelSensor(sensors, SENSOR_CODE.FUEL_DIGITAL, [
      SENSOR_PIN_CODE.FUEL_LEVEL_OBD_1,
      SENSOR_PIN_CODE.FUEL_LEVEL_OBD_2,
    ])
  ) {
    return 'OBD'
  } else if (isHaveFuelSensor(sensors, SENSOR_CODE.FUEL_DIGITAL)) {
    return 'Digital'
  } else if (isHaveFuelSensor(sensors, SENSOR_CODE.FUEL_ODO)) {
    return 'Odo'
  } else if (isHaveFuelSensor(sensors, SENSOR_TYPE.FUEL_STICK)) {
    return 'Stick'
  } else if (isHaveFuelSensor(sensors, SENSOR_CODE.FUEL_ULTRASONIC)) {
    return 'Ultrasonic'
  }
  return '-'
}
